import {ModelsApi} from 'hemwb-api';
import {configuration} from '../getBackendConfiguration';

const modelsApi = new ModelsApi(configuration);

export const requestHasViewedGuidedTour = (type: string, code: string) =>
  modelsApi.getHasViewedGuidedTour({type, code});
